module.exports = __webpack_public_path__ + "img/gzhqrcode.5af4490b.jpg";